import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import {
  MdOutlineKeyboardArrowLeft,
  MdOutlineSupportAgent,
  MdCurrencyRupee,
} from "react-icons/md";
import { SiNeteasecloudmusic } from "react-icons/si";
import { Card, Container, Modal } from "react-bootstrap";
import { TfiWallet } from "react-icons/tfi";
import { IoMdRefresh } from "react-icons/io";
import { AiFillSound } from "react-icons/ai";
import { FaGripfire } from "react-icons/fa";
import axios from "axios";
// import { useCredit } from "./CreditContext";
import { fetchWithAuth, logoutUser } from "./authApi";
import { useNavigate } from "react-router-dom";
// import jalwaGame from "../../../src/assets/images/jalwaGame.png";

export default function WingoChart({ message }) {
  const user_id = localStorage.getItem("user_id");
  const isLoading = useRef(false);
  const [loading, setLoading] = useState(false);
  const [images, setImage] = useState([]);
  const [userData, setUserData] = useState(null);
  const navigate = useNavigate();

  const { credit, updateCredit } = 10;

  useEffect(() => {
    if (!isLoading.current) {
      fetchGames();
    }
  }, [message]);

  const fetchGames = async () => {
    try {
      isLoading.current = true;
      setLoading(true);
      const response = await fetchWithAuth(
        `${process.env.REACT_APP_API_URL}profile-list`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ user_status: "1" }),
        },
      );

      const responseData1 = await response.json();
      const responseData = responseData1.data;

      setUserData(responseData);
      const credit = responseData.credit;
      updateCredit(credit);

      isLoading.current = false;
      setLoading(false);
    } catch (error) {
      isLoading.current = false;
      console.error("Error fetching user data:", error);
      setLoading(false);
    }
  };

  const placeBet = async () => {
    try {
      // Your code to place the bet goes here

      // After placing the bet, refresh the credit
      await fetchGames();
    } catch (error) {
      console.error("Error placing bet:", error);
    }
  };
  const Depositshow = () => {
    localStorage.setItem("deps", "true"); // stored as string
    navigate("/Deposit");
  };
  return (
    <section className="wingoheader">
      <div className="wingo padding_all">
        {/* <div className="topheader p-2 all_header_color d-flex justify-content-between align-items-center">
          <Link to="/home" className="text-white text-2xl">
            <MdOutlineKeyboardArrowLeft />
          </Link>
          <div className="mb-0 text-white word-spacing-sm">
            <img src={jalwaGame} alt="game" style={{ width: "8.5rem" }} />
          </div>

          <div className="d-flex">
            <Link to="/home" className="w-5 text-white">
              <MdOutlineSupportAgent />
            </Link>
            <SiNeteasecloudmusic className="w-5 text-white" />
          </div>
        </div> */}
        <div className="allbefore position-relative">
          <Container>
            <Card className="mt-2 points_left_right">
              <Card.Body className="bg_color_all_wingo">
                <h3 className="text-white d-flex mb-0 align-items-center gap-1 justify-content-center">
                  <MdCurrencyRupee className="text-md" />
                  {(Number(credit) || 0).toFixed(2)}{" "}
                  <svg
                    data-v-7d799898=""
                    class="svg-icon refreshbutton icon-refreshBalance"
                  >
                    <use href="#icon-refreshBalance"></use>
                  </svg>
                </h3>
                <p className="d-flex text-white mb-0 align-items-center gap-1 justify-content-center">
                  <svg
                    data-v-7d799898=""
                    class="svg-icon walleticon_all  icon-lottyWallet"
                  >
                    <use href="#icon-lottyWallet"></use>
                  </svg>
                  Wallet Balance
                </p>
                <div className="d-flex gap-2 justify-content-evenly align-items-center">
                  <Link
                    to="/Withdraw"
                    className="buttonall no-underline rounded-full"
                    style={{ "--bgcolor": "#d23838" }}
                  >
                    <span>Withdraw</span>
                  </Link>
                  <button
                    // to="/Deposit"
                    onClick={Depositshow}
                    className="buttonall no-underline rounded-full"
                    style={{ "--bgcolor": "#17b05d" }}
                  >
                    <span>Deposit</span>
                  </button>
                </div>
              </Card.Body>
            </Card>
            <div className="Marquee_Tag">
              <div className="d-flex justify-content-between align-items-center">
                <div className="h-25 w-28 sound_icon">
                  <AiFillSound />
                </div>
                <div className="Notice">
                  <p className="">
                    Our customer service never sends a link to the member. If
                    you received a link from someone who proclaimed as customer
                    service, do not click the link to prevent being hacked or
                    losing data. Thank you
                  </p>
                </div>
                <div className="details">
                  <Link to="/Details" style={{ textDecoration: "none" }}>
                    <button className="align-items-center d-flex">
                      <FaGripfire />
                      Details
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </Container>
        </div>
      </div>
    </section>
  );
}
